module.exports = __webpack_public_path__ + "static/media/boxChatInactive.83bbbdf2.svg";